import type {
	BroadcastableCommandConstructor,
	CommandConstructor,
	CommandProperties,
} from './bridge-api-command-types';

/**
 * Type guard to determine if a given command constructor is broadcastable.
 *
 * Encapsulates the runtime flag check so call sites don't need casts.
 */
export function isBroadcastableCommand<C extends CommandProperties = CommandProperties>(
	command: CommandConstructor<C>,
): command is BroadcastableCommandConstructor<C> {
	return (
		typeof command === 'function' &&
		(command as { __broadcastable?: unknown }).__broadcastable === true
	);
}
